import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const CancelV2ATransfer = gql`
  mutation cancelV2ATransfer($transferId: ID!) {
    cancelV2ATransfer(input: { transferId: $transferId }) {
      ... on CancelV2ATransferResultSuccess {
        success
        __typename
      }
      ... on CancelV2ATransferResultError {
        ...error
      }
    }
  }
  ${error}
`;

export default CancelV2ATransfer;
